import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Divider = ({ theme, className }) => (
    <span className={ classnames({
        [theme.dividerWrapper]: true,
        [className]: className,
    }) }
    >
        <span className={ theme.divider } />
    </span>
);

Divider.propTypes = {
    theme: PropTypes.shape({}),
    className: PropTypes.string,
};

Divider.defaultProps = {
    className: '',
};

export default Divider;

